import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"

export function getColumns(onDelete, onEdit) {
  return [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
      width: 300,
      sorter: (a, b) => a.date - b.date
    },

    {
      title: "Тип получения",
      dataIndex: "deliveryTypeName",
      key: "deliveryTypeName",
      width: 200,
      render: (value, record) => (
        <Tag color={record.deliveryType === "pickup" ? "blue" : "green"}>{value}</Tag>
      ),
    },

    {
      title: "Точки",
      dataIndex: "points",
      key: "points",
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
              <Popconfirm
                placement="left"
                title="Действительно хотите удалить?"
                onConfirm={() => onDelete(record.id)}
                onCancel={() => stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <TrashSvg />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    }] : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}